var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectors15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 852,
    height: 852,
    viewBox: "0 0 852 852",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M694.114 132.222C735.507 169.492 768.613 215.039 791.289 265.914L427.892 427.891L694.114 132.222Z",
    fill: "url(#paint0_linear_90_21)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M550.839 49.502C603.813 66.7142 652.582 94.8576 693.991 132.111L427.893 427.892L550.839 49.502Z",
    fill: "url(#paint1_linear_90_21)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M550.84 806.281C497.866 823.493 441.869 829.391 386.471 823.592L427.894 427.892L550.84 806.281Z",
    fill: "url(#paint2_linear_90_21)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M694.113 723.561C652.72 760.831 603.963 788.995 550.996 806.229L427.891 427.891L694.113 723.561Z",
    fill: "url(#paint3_linear_90_21)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M791.359 589.716C768.704 640.601 735.617 686.161 694.24 723.449L427.894 427.891L791.359 589.716Z",
    fill: "url(#paint4_linear_90_21)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M825.756 427.891C825.756 483.591 814.061 538.67 791.427 589.564L427.894 427.891L825.756 427.891Z",
    fill: "url(#paint5_linear_90_21)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M791.358 266.066C814.014 316.95 825.732 372.025 825.755 427.724L427.893 427.891L791.358 266.066Z",
    fill: "url(#paint6_linear_90_21)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M386.304 823.574C330.909 817.752 277.354 800.363 229.105 772.534L427.892 427.891L386.304 823.574Z",
    fill: "url(#paint7_linear_90_21)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7244 510.612C27.1437 456.129 27.1319 399.822 38.6897 345.334L427.892 427.892L38.7244 510.612Z",
    fill: "url(#paint8_linear_90_21)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M106.016 661.749C73.276 616.687 50.363 565.253 38.7595 510.775L427.893 427.892L106.016 661.749Z",
    fill: "url(#paint9_linear_90_21)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M228.963 772.45C180.725 744.6 138.873 706.932 106.114 661.884L427.894 427.891L228.963 772.45Z",
    fill: "url(#paint10_linear_90_21)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M386.305 32.209C441.7 26.3868 497.7 32.2607 550.681 49.4507L427.893 427.892L386.305 32.209Z",
    fill: "url(#paint11_linear_90_21)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M228.962 83.3325C277.199 55.4826 330.747 38.0715 386.139 32.226L427.893 427.891L228.962 83.3325Z",
    fill: "url(#paint12_linear_90_21)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.015 194.034C138.755 148.972 180.591 111.286 228.817 83.4161L427.893 427.892L106.015 194.034Z",
    fill: "url(#paint13_linear_90_21)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7234 345.172C50.304 290.689 73.1954 239.245 105.916 194.169L427.891 427.892L38.7234 345.172Z",
    fill: "url(#paint14_linear_90_21)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_90_21",
    x1: 568.275,
    y1: 222.972,
    x2: 720.837,
    y2: 393.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_90_21",
    x1: 472.792,
    y1: 183.59,
    x2: 681.346,
    y2: 276.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_90_21",
    x1: 561.903,
    y1: 692.8,
    x2: 292.633,
    y2: 651.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_90_21",
    x1: 617.014,
    y1: 588.926,
    x2: 431.907,
    y2: 722.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_90_21",
    x1: 660.953,
    y1: 521.909,
    x2: 505.084,
    y2: 691.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_90_21",
    x1: 656.905,
    y1: 568.205,
    x2: 672.405,
    y2: 405.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9176DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805FDA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_90_21",
    x1: 653.709,
    y1: 317.605,
    x2: 675.319,
    y2: 546.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_90_21",
    x1: 410.495,
    y1: 678.597,
    x2: 201.196,
    y2: 582.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_90_21",
    x1: 193.871,
    y1: 511.159,
    x2: 170.423,
    y2: 283.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_90_21",
    x1: 229.942,
    y1: 582.718,
    x2: 161.15,
    y2: 363.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_90_21",
    x1: 333.183,
    y1: 657.52,
    x2: 148.591,
    y2: 522.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_90_21",
    x1: 369.544,
    y1: 186.449,
    x2: 598.03,
    y2: 186.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_90_21",
    x1: 285.553,
    y1: 230.46,
    x2: 520.292,
    y2: 169.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_90_21",
    x1: 147.665,
    y1: 328.002,
    x2: 410.981,
    y2: 154.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8362DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B3EAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_90_21",
    x1: 180.378,
    y1: 384.384,
    x2: 297.615,
    y2: 186.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4A9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A60C0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectors15);
export default __webpack_public_path__ + "static/media/sectors-15.352288484ee5eb2e6e66a0a7e929b3bc.svg";
export { ForwardRef as ReactComponent };